exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-container-3uhxT{display:inline}.style-cssmodule-badge-3vpXy{padding:2px 8px;width:fit-content;background-color:var(--bg);color:var(--color);text-align:center;font-size:12px;font-weight:500;line-height:16px;border-radius:28px;letter-spacing:.12px}.style-cssmodule-badge-3vpXy[data-type=ASSIGNED]{--bg:#fcead5;--color:#c67c3d}.style-cssmodule-badge-3vpXy[data-type=BOOKING]{--bg:#fff7d6;--color:#cca206}.style-cssmodule-badge-3vpXy[data-type=ON_DEMAND]{--bg:#e1e8ff;--color:#1147b7}.style-cssmodule-badge-3vpXy[data-type=REGULAR]{--bg:#ede6fc;--color:#7143c3}", ""]);

// exports
exports.locals = {
	"container": "style-cssmodule-container-3uhxT",
	"badge": "style-cssmodule-badge-3vpXy"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/cpm/routes/parkings/components/ParkingType/style.cssmodule.css
// module id = 2558
// module chunks = 121